import React from "react";

export default function Vision() {
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative bg-[#F2EBE1] py-24 lg:py-36"
    >
      <div className="max-w-[1200px] mx-auto px-6 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="sdm-divider">Notre Vision</p>
          <h2 className="font-serif-display text-4xl lg:text-5xl text-[#4A192C] mt-8 leading-tight">
            Un sanctuaire, pas un dispositif.
          </h2>
        </div>
        <div className="lg:col-span-8 space-y-7 text-[1.05rem] leading-relaxed text-[#2C1E23]/90">
          <p className="font-serif-display italic text-2xl text-[#4A192C]">
            Nous ne soignons pas des victimes.
            <br />
            Nous accueillons des reines qui se souviennent d&apos;elles-mêmes.
          </p>
          <p>
            Porté par l&apos;association <strong>Les Mamans Reines</strong>, Le
            Sanctuaire des Mères est un refuge urbain parisien unique en son
            genre. Ici, les mères victimes de violences conjugales ne sont
            plus définies par ce qu&apos;elles ont subi, mais par la dignité
            qu&apos;elles incarnent.
          </p>
          <p>
            Refuge, transmission, renaissance — trois gestes sacrés pour
            transformer un espace de fuite en un espace de reconstruction. Un
            modèle duplicable, pensé pour essaimer dans d&apos;autres villes
            de France.
          </p>

          <div className="grid sm:grid-cols-3 gap-6 pt-6">
            {[
              { k: "Refuge", d: "Un lieu sûr, secret, accueillant." },
              { k: "Transmission", d: "Partager la force d'une génération à l'autre." },
              { k: "Renaissance", d: "Ritualiser chaque étape de la reconstruction." },
            ].map((b) => (
              <div
                key={b.k}
                className="border-t border-[#4A192C]/30 pt-4"
                data-testid={`vision-pillar-${b.k.toLowerCase()}`}
              >
                <div className="font-serif-display text-2xl text-[#C5A059]">{b.k}</div>
                <div className="text-sm text-[#6B585F] mt-2">{b.d}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
